import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Resets scroll on client-side navigation. Mounted once under <BrowserRouter>.
 *
 *   - PUSH (a link click)  -> jump to the top instantly. Not smooth: a smooth
 *     scroll across a full page change reads as motion sickness.
 *   - POP (back / forward) -> do nothing, so the browser restores the scroll
 *     position the user was at.
 *   - a #hash target       -> scroll that element into view instead of the top
 *     (also covers hard loads of "/#programs" from the header's anchor links).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      // let the destination route paint before locating the anchor
      const t = setTimeout(() => document.getElementById(id)?.scrollIntoView(), 100);
      return () => clearTimeout(t);
    }
    if (navType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navType]);

  return null;
};

export default ScrollToTop;
